export default __webpack_public_path__ + "static/d12-e062bfbf0d0c8458d02b828ec0a71767.png";